import { MapPin, Clock, Phone, CheckCircle2 } from "lucide-react";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const addDays = (iso, n) => { const d = new Date(iso); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

// "This week's site visits" — seven columns (Mon–Sun) so the team sees the week at a glance.
export function WeekVisitsStrip({ events, weekStart, today, selectedDate, onSelectDate, onOpenBooking }) {
  if (!weekStart) return null;
  const days = DAYS.map((label, i) => {
    const date = addDays(weekStart, i);
    return { label, date, visits: events.filter(e => e.type === "site_visit" && e.date === date) };
  });
  const total = days.reduce((a, d) => a + d.visits.length, 0);
  return (
    <section data-testid="week-visits-strip" className="mb-8 border border-[#E5E7EB] bg-white">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-[#E5E7EB] bg-[#FAFAFA]">
        <div className="text-[10px] uppercase tracking-widest font-black text-[#12263A] inline-flex items-center gap-2">
          <MapPin size={13} className="text-[#5B2A83]" /> This week&apos;s site visits
        </div>
        <div className="text-xs font-bold text-[#6B7280]" data-testid="week-visits-count">{total} {total === 1 ? "visit" : "visits"}</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 divide-y sm:divide-y-0 lg:divide-x divide-[#F0EAE0]">
        {days.map(d => {
          const isToday = d.date === today;
          const isPast = d.date < today;
          const isSelected = d.date === selectedDate;
          return (
            <div key={d.date} data-testid={`week-day-${d.date}`} className={`p-3 min-h-[92px] ${isToday ? "bg-[#FBF7EF]" : ""} ${isPast ? "opacity-60" : ""} ${isSelected ? "ring-2 ring-inset ring-[#C79A3B]" : ""}`}>
              <button type="button" data-testid={`week-day-select-${d.date}`} onClick={() => onSelectDate?.(d.date)} title="Plan this day's route"
                className="flex items-baseline gap-1.5 mb-2 hover:underline decoration-[#C79A3B]">
                <span className={`text-[10px] font-black uppercase tracking-widest ${isToday ? "text-[#C79A3B]" : "text-[#6B7280]"}`}>{isToday ? "Today" : d.label}</span>
                <span className="text-xs font-bold text-[#12263A]">{new Date(d.date).getDate()}</span>
              </button>
              {d.visits.length === 0 && <div className="text-[11px] text-[#9CA3AF]">—</div>}
              <div className="space-y-1.5">
                {d.visits.map(v => (
                  <button key={`${v.reference}-${v.time}`} type="button" data-testid={`week-visit-${v.reference}`}
                    onClick={() => onOpenBooking?.(v.reference)} title={`${v.address || v.postcode || ""}${v.phone ? ` · ${v.phone}` : ""}`}
                    className="w-full text-left border-l-2 border-[#5B2A83] bg-[#F5EEFA] hover:bg-[#EADBF3] px-2 py-1.5 transition-colors">
                    <div className="text-[11px] font-black text-[#12263A] inline-flex items-center gap-1">
                      <Clock size={10} className="text-[#5B2A83]" /> {v.time || "TBC"}
                      {v.visit_status === "done" && <CheckCircle2 size={10} className="text-[#1F6B3B]" />}
                    </div>
                    <div className="text-xs font-semibold text-[#12263A] truncate">{v.client_name || v.reference}</div>
                    <div className="text-[10px] text-[#6B7280] truncate">{v.postcode || v.address || ""}</div>
                    {v.phone && <div className="text-[10px] text-[#6B7280] inline-flex items-center gap-1"><Phone size={9} /> {v.phone}</div>}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
